<div class="export-download-container">
  <div class="export-download-card">

    <div *ngIf="loading" class="export-download-state">
      <span class="spinner"></span>
      <h2>{{ 'files.export-download.preparing-title' | translate }}</h2>
      <p>{{ 'files.export-download.preparing-body' | translate }}</p>
    </div>

    <div *ngIf="!loading && resolvedState === 'DOWNLOADING'" class="export-download-state download-starting">
      <h2>{{ 'files.export-download.download-starting-title' | translate }}</h2>
      <p>{{ 'files.export-download.download-starting-body' | translate }}</p>
      <button type="button" class="btn btn-primary-light" (click)="backToFiles()">
        {{ 'files.export-download.back-to-files' | translate }}
      </button>
    </div>

    <div *ngIf="!loading && resolvedState === 'DELETED'" class="export-download-state gone">
      <h2>{{ 'files.export-download.deleted-title' | translate }}</h2>
      <p>{{ 'files.export-download.deleted-body' | translate }}</p>
      <button type="button" class="btn btn-primary-light" (click)="backToFiles()">
        {{ 'files.export-download.create-new' | translate }}
      </button>
    </div>

    <div *ngIf="!loading && resolvedState === 'EXPIRED'" class="export-download-state gone">
      <h2>{{ 'files.export-download.expired-title' | translate }}</h2>
      <p>{{ 'files.export-download.expired-body' | translate }}</p>
      <button type="button" class="btn btn-primary-light" (click)="backToFiles()">
        {{ 'files.export-download.create-new' | translate }}
      </button>
    </div>

    <div *ngIf="!loading && resolvedState === 'FAILED'" class="export-download-state failed">
      <h2>{{ 'files.export-download.failed-title' | translate }}</h2>
      <p>{{ failureMessage }}</p>
      <button type="button" class="btn btn-primary-light" (click)="backToFiles()">
        {{ 'files.export-download.create-new' | translate }}
      </button>
    </div>

    <div *ngIf="!loading && resolvedState === 'NOT_FOUND'" class="export-download-state gone">
      <h2>{{ 'files.export-download.not-found-title' | translate }}</h2>
      <p>{{ 'files.export-download.not-found-body' | translate }}</p>
      <button type="button" class="btn btn-primary-light" (click)="backToFiles()">
        {{ 'files.export-download.back-to-files' | translate }}
      </button>
    </div>

  </div>
</div>
